import { gql } from '@soundxyz/gql-string';
import type { FragmentType } from '@graphql/reactQuery';
import { AudienceSeatCountFragmentDoc, getFragment } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment AudienceSeatCount on Release {
    id
    numSold
    quantity
    quantityUpperBound
    finalQuantity
    supplyCutoffTimestamp
  }
`);

// Missing Test
// TODO: https://linear.app/sound/issue/ENG-2488/add-tests-for-usereleasequantities
export function useAudienceSeatCount({
  release: releaseFragment,
}: {
  release: FragmentType<AudienceSeatCountFragmentDoc> | null | undefined;
}) {
  const release = getFragment(AudienceSeatCountFragmentDoc, releaseFragment);
  if (!release) {
    return {
      numberOfSeats: 0,
      isBeforeFinalSaleEndTime: false,
    };
  }

  const { finalQuantity, quantity: quantityLowerBound, quantityUpperBound, numSold } = release;

  const currentMaxQuantity = finalQuantity ?? quantityUpperBound;
  const remaining = currentMaxQuantity - numSold;

  const isBeforeFinalSaleEndTime =
    release?.supplyCutoffTimestamp != null && Date.now() < release.supplyCutoffTimestamp;

  // finalQuantity means we have a fixed number of seats
  // for range/open, show the lower bound initially, and then numSold when between the range
  const numberOfSeats = finalQuantity || Math.max(quantityLowerBound, numSold);

  return {
    numberOfSeats,
    isBeforeFinalSaleEndTime,
    numSold,
    remaining,
    quantityUpperBound,
    quantityLowerBound,
  };
}
